module.exports = __webpack_public_path__ + "static/media/desktop-picture-medium.66e833a9.jpeg";